import {IEntryForShow} from '../_interface/ientry-for-show';
import {IEntryByDrawings} from '../_interface/entries-types.type';
import {slugify} from 'shared/_functions/slugify';
import {DrawSchema} from '../lib/drawing/_interface/schema.model';
import {JournalSymbolField} from '../_interface/journal-symbol-field.interface';
import dayjs from 'dayjs';
import {Dictionary} from '@ngrx/entity';

export enum ByDataSections {
	warnings = 'warnings',
	medicine = 'medicine',
	pulse = 'pulse'
}

export const prepareEntriesByDrawings = (
	entriesList: IEntryForShow[],
	entriesDict: Dictionary<IEntryForShow>,
	symbolFields: JournalSymbolField[],
	schemas: Dictionary<DrawSchema>
) => {
	const schemaRec = symbolFields.reduce<Record<string, JournalSymbolField[]>>((rec, sf) => {
		rec[sf.schemaId] = rec[sf.schemaId] ? [...rec[sf.schemaId], sf] : [sf];
		return rec;
	}, {});
	let missingSchemaEntries: string[] = [];
	let schemaEntries: string[] = [];
	const schemaSections: IEntryByDrawings[] = Object.entries(schemaRec).map(([schemaId, sf]) => {
		const sortedSymbolFields = sf.sort((a, b) =>
			dayjs(a.field.content.lastEntry.modificationDate).isAfter(b.field.content.lastEntry.modificationDate) ? -1 : 1
		);
		const uniq = Array.from(new Set(sortedSymbolFields.map(({entryId}) => entryId)));
		const entries = uniq.map((entryId) => entriesDict[entryId]);
		schemaEntries = [...schemaEntries, ...uniq];
		if (!schemas[schemaId]) {
			missingSchemaEntries = [...missingSchemaEntries, ...uniq];
			return null;
		}
		return {
			schema: schemas[schemaId],
			name: schemas[schemaId].name,
			visible: true,
			entries,
			sectionId: `section-${slugify(schemas[schemaId].name)}`,
		};
	}).filter(Boolean);
	const restSection: IEntryByDrawings = {
		name: 'without schema',
		visible: true,
		sectionId: 'section-drawings-rest',
		entries: [
			...entriesList.filter(({entryId}) => !schemaEntries.includes(entryId)),
			...entriesList.filter(({entryId}) => missingSchemaEntries.includes(entryId))
		]
	};
	return [...schemaSections, restSection];
};
